import { CashFtBundleIds } from "./CashFtBundleIds";

export const CashFtBundleNamesById = {
    [CashFtBundleIds.PLASTIC]: "Explorer",
    [CashFtBundleIds.METAL]: "Mastery",
} as const;
